const getTubeVariations = (commonCanopies, commonVariaton) => {
	return {
		'6160': {
			...commonVariaton,
			size: {
				width: 0.22,
				height: 0.118,
				depth: 0.22
			},
			paddingTop: -0.35,
			familyName: 'tube',
			related: ['6160', '6165'],
			canopy: {
				...commonCanopies,
				"10": {
					...commonCanopies['10'],
					source: '/models/canopy_skan.glb',
					size: {
						width: 0.16,
						depth: 0.16,
						height: 0.033
					},
				}
			},
			light: {
				type: 'spot',
				power: 199,
				options: { angle: Math.PI / 8 }
			}
		},
		'6165': {
			...commonVariaton,
			size: {
				width: 0.285,
				height: 0.148,
				depth: 0.285
			},
			paddingTop: -0.35,
			familyName: 'tube',
			related: ['6160', '6165'],
			canopy: {
				...commonCanopies,
				"10": {
					...commonCanopies['10'],
					source: '/models/canopy_skan.glb',
					size: {
						width: 0.16,
						depth: 0.16,
						height: 0.033
					},
				}
			},
			light: {
				type: 'spot',
				power: 199,
				options: { angle: Math.PI / 8 }
			}
		}
	}
}

export default getTubeVariations